import React from "react";
import { Component } from "react";
import {
  Modal,
  Button,
  Col,
  Row,
  Card,
  Slider,
  Select,
  Form,
  Tooltip
} from "antd";
import { isEmail, sendNotification } from "../../../utils";
import { injectIntl } from "react-intl";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import {
  newInvitation,
  userExistsByEmail,
  userExistsReset
} from "../../../actions/UsersAction";
import moment from "moment";
import { updateClientes } from "../../../actions/ClientAction";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import _ from "lodash";
import {
  updateClientPlans,
  calculateDiff,
  isEnterpriseUser
} from "../../../utils/plan-utils";
import {
  updatePlanServicesByUser,
  updatePlanLinkGenerate,
  reducePlan
} from "../../../actions/PlanServicesAction";
import { getClientDataById } from "../../../actions/ClientAction";
import { USAGE_TERMS_LINK_FROM_HOME } from "../../sign-in-modal/sign-in-utils";
import { freePlanPrice } from "../../../utils/constants";

const { Option } = Select;

export class AddModalUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      visible: false,
      email: "",
      terms: false,
      password: "",
      role: "operator",
      userType: "Infinite",
      group: [],
      options: [],
      userPacksOld: [],
      initDate: moment().format("YYYY-MM-DD"),
      dueDate: moment().format("YYYY-MM-DD"),
      message: "",
      sendingInvitation: false,
      updatingClient: false,
      cart: [],
      userPacks: [],
      dataDiff: []
    };
  }

  componentDidMount() {
    this.props.userExistsReset();
    const { group } = this.props;
    this.setState({
      options: group.map((r, k) => (
        <Option key={k} value={r.name} uid={r._id}>
          {r.name}
        </Option>
      ))
    });
    this.updateUserPacks();
  }

  updateUserPacks = () => {
    const ids = (this.props.userServices || []).map(e =>
      e.idService ? e.idService : e.idService
    );
    const userPacks = [];
    for (const idx in this.props.planServices) {
      if (ids.includes(this.props.planServices[idx].idService)) {
        const index = ids.indexOf(this.props.planServices[idx].idService);
        if (index >= 0) {
          userPacks.push({
            ...this.props.planServices[idx],
            quantity: this.props.userServices[index].quantity,
            idService: this.props.userServices[index].idService
          });
        }
      }
    }
    const freeServices = (this.props.userServices || []).filter(
      e => e.is_free === "true"
    );
    const toSave = freeServices.map(e => ({
      ...e,
      _id: e.idService,
      is_free: "true"
    }));
    userPacks.push(...toSave);
    this.setState({
      userPacks: userPacks,
      userPacksOld: userPacks
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { userPacks: oldData } = prevState;

    const { userPacks: newData } = this.state;

    const {
      reducePlanLoading: reducePlanLoadingOld,
      linkGenerateLoading: linkGenerateLoadingOld,
      fetchingUserServices: fetchingUserServicesOld
    } = prevProps;

    const {
      invitationSent,
      intl,
      clientUpdate,
      userServices,
      reducePlanLoading: reducePlanLoadingNew,
      reducePlanError,
      workclient,
      handleHiddenAddModalUser,
      linkGenerateLoading: linkGenerateLoadingNew,
      linkGenerateError,
      linkGenerate,
      showAddModalUser,
      fetchingUserServices: fetchingUserServicesNew
    } = this.props;

    if (this.props.showAddModalUser !== prevProps.showAddModalUser) {
      if (!this.state.visible) {
        this.updateUserPacks();
      }
    }

    if (prevProps.invitationSent !== invitationSent && invitationSent) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "invitation_sended_success" })
      );
      this.handleClearForm();
    }

    if (clientUpdate && clientUpdate !== prevProps.clientUpdate) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "client_edit_successfully" })
      );
      this.handleCancel();
    }
    if (this.props.userServices !== prevProps.userServices) {
      this.updateUserPacks();
    }

    if (fetchingUserServicesOld && !fetchingUserServicesNew) {
      this.props.getClientDataById(workclient);
    }

    if (newData !== oldData) {
      const { group } = this.props;
      const newDiff = calculateDiff(userServices, newData);
      this.setState({
        dataDiff: newDiff,
        options: group.map((r, k) => (
          <Option key={k} value={r.name} uid={r._id}>
            {r.name}
          </Option>
        ))
      });
    }
    if (reducePlanLoadingOld && !reducePlanLoadingNew && !reducePlanError) {
      if (!showAddModalUser) return;
      const newDataClean = newData.filter(e => e.idService);
      this.props.updatePlanServicesByUser(
        workclient,
        newDataClean.map(x => ({ ...x, qty: x.quantity })),
        intl
      );
      handleHiddenAddModalUser();
    }
    if (
      linkGenerateLoadingOld &&
      !linkGenerateLoadingNew &&
      !linkGenerateError &&
      linkGenerate
    ) {
      if (!showAddModalUser) return;
      window.open(linkGenerate, "_self", "noreferrer");
    }
  }

  handleClearForm = () => {
    this.setState({
      email: "",
      message: "",
      terms: false,
      group: [],
      sendingInvitation: false,
      updatingClient: false
    });
  };

  handleEmailExists = e => {
    const { workclient } = this.props;
    if (e.target.value === "") {
      this.props.userExistsReset();
    } else if (isEmail(e.target.value)) {
      this.props.userExistsByEmail(workclient, e.target.value);
    }
  };

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleCancel = () => {
    this.setState({
      step: 1,
      visible: false,
      sendingInvitation: false,
      updatingClient: false,
      email: "",
      terms: false
    });
    this.props.handleHiddenAddModalUser();
  };

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleCheckboxOnChange = e => {
    this.setState({
      [e.target.name]: e.target.checked
    });
  };

  sendInvitation = () => {
    const {
      intl,
      workclient,
      userExists,
      handleHiddenAddModalUser
    } = this.props;
    const {
      email,
      role,
      userType,
      group,
      initDate,
      dueDate,
      message
    } = this.state;

    if (email === "") {
      this.props.userExistsByEmail(workclient, email);
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "empty_email_input" })
      );
      return;
    } else if (userExists === "UserAlreadyExist") {
      this.props.userExistsReset();
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "existing_associated_mail" })
      );
      return;
    } else if (!isEmail(email)) {
      this.props.userExistsByEmail(workclient, email);
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "not_valid_email" })
      );
      return;
    } else if (group.length === 0) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "not_valid_group" })
      );
      return;
    }

    this.setState(
      {
        sendingInvitation: true
      },
      () => {
        this.props.newInvitation(
          email,
          role,
          workclient,
          group,
          userType,
          initDate,
          dueDate,
          message,
          handleHiddenAddModalUser
        );
      }
    );
  };

  addUserPackQty = (id, qty) => {
    const { userPacks } = this.state;
    const ind = userPacks.findIndex(item => item.idService === id);

    if (ind >= 0) {
      userPacks[ind].quantity += qty;
      if (userPacks[ind].quantity < 0) userPacks[ind].quantity = 0;
      this.setState({
        userPacks: userPacks.filter(e => e.quantity > 0)
      });
    } else {
      const newItem = this.props.planServices.find(e => e.idService === id);
      if (newItem) {
        this.setState({
          userPacks: [
            ...this.state.userPacks,
            {
              ...newItem,
              quantity: 1
            }
          ]
        });
      }
    }
  };
  updateUserPackQty = (id, qty) => {
    const { userPacks } = this.state;
    const ind = userPacks.findIndex(item => item.idService === id);

    if (ind >= 0) {
      userPacks[ind].quantity = qty;
      if (userPacks[ind].quantity < 0) userPacks[ind].quantity = 0;
      this.setState({ userPacks });
    }
  };

  addSpacePackQty = (id, qty) => {
    const { spacePacks } = this.state;
    const ind = spacePacks.findIndex(item => item.id === id);
    if (ind >= 0) {
      spacePacks[ind].qty += qty;
      if (spacePacks[ind].qty < 0) spacePacks[ind].qty = 0;
      this.setState({ spacePacks });
    }
  };

  addToCart = (id, product, qty) => {
    const { cart } = this.state;

    const ind = cart.findIndex(item => item.product.id === id);
    if (ind >= 0) {
      cart[ind].qty += qty;
      if (cart[ind].qty < 0) cart[ind].qty = 0;
    } else {
      cart.push({ product, qty });
    }
    this.setState({ cart });
  };

  calculateTotal = () => {
    const { userPacks } = this.state;
    let sum = freePlanPrice;

    for (const item of userPacks) {
      sum += item.quantity * Number(item.price);
    }

    return sum;
  };

  nextStep = () => {
    const { intl } = this.props;
    const { step, cart, userPacksOld } = this.state;

    if (step === 1) {
      if (this.calculateTotal() === 0 && userPacksOld.length < 3) {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "cart_is_empty" })
        );
        return;
      }

      const sortedByCat = cart.sort((p1, p2) => {
        return p1.product.category < p2.product.category
          ? 1
          : p1.product.category > p2.product.category
          ? -1
          : 0;
      });

      this.setState({
        cart: sortedByCat,
        step: step + 1
      });
    }
  };

  previewStep = () => {
    // const {intl} = this.props;
    // const {step, cart} = this.state;
    this.setState({
      step: 1,
      terms: false,
      role: "operator",
      userType: "Infinite",
      sendingInvitation: false,
      updatingClient: false
    });
  };

  updateClient = () => {
    const { client, intl, workclient } = this.props;
    const { userPacks: data, dataDiff } = this.state;
    const { usersData, planServices } = this.props;

    const resp = updateClientPlans(
      client,
      intl,
      data,
      dataDiff,
      usersData,
      planServices
    );
    if (resp.action === "error") return;
    if (resp.action === "reduce_plan") {
      this.props.reducePlan(workclient, resp.data.amount, intl);
      return;
    }
    if (resp.action === "update_plan") {
      this.props.updatePlanLinkGenerate(
        workclient,
        resp.data.amount,
        intl,
        resp.data.modules
      );
      return;
    }
  };
  handleOnChangeGroup = (item, list) => {
    this.setState({ group: list.map(r => r.props.uid) });
  };

  userServices = () => this.props.planServices.filter(e => e.type === "1");
  storageServices = () => this.props.planServices.filter(e => e.type === "2");

  render() {
    const {
      showAddModalUser,
      handleHiddenAddModalUser,
      data,
      contractedUsers,
      intl,
      newColor,
      reducePlanLoading,
      linkGenerateLoading,
      client,
      userServices
    } = this.props;

    const {
      step,
      email,
      terms,
      sendingInvitation,
      options,
      role,
      dataDiff
    } = this.state;

    const registeredUsers = data.filter(
      user =>
        user.status &&
        user.typeRoleFilter === "Infinite" &&
        user.email.indexOf("@bunkey.tv") === -1 &&
        user.roleLower !== "superadmin"
    ).length;

    const disableCreateUser =
      registeredUsers >= contractedUsers || sendingInvitation;
    const results = userServices
      ? userServices.find(({ product }) => product === "Sistema de grupos")
      : null;
    const hireds = _.isNil(results);
    const selected = {
      defaultValue: "Mi Equipo"
    };
    if (!_.isNil(results)) {
      Reflect.deleteProperty(selected, "defaultValue");
    }
    return (
      <React.Fragment>
        <Modal
          visible={showAddModalUser}
          onCancel={handleHiddenAddModalUser}
          footer={null}
          className="modal-parent modal-pay"
          scrollableBody={true}
          style={{ top: !isEnterpriseUser(client) ? 40 : "true" }}
          closeIcon={<img src={CloseIcon} alt={"icon close"} />}
          destroyOnClose
          centered={!isEnterpriseUser(client) ? false : true}
        >
          <div
            hidden={step !== 1}
            id="step1"
            className="step"
            style={{ paddingTop: "50px" }}
          >
            <div
              className="scroll-step"
              style={{
                overflow: "auto",
                overflowX: "hidden",
                height: !isEnterpriseUser(client) ? "70vh" : "auto",
                scrollbarTrackColor: "white",
                marginBottom: "5px"
              }}
            >
              <Row gutter={25}>
                <Col md={14} lg={14} xs={23} span={14}>
                  <h3
                    style={{
                      color: "var(--primary-color)",
                      paddingBottom: "5px"
                    }}
                  >
                    <b>{ !isEnterpriseUser(client) ? intl.formatMessage({id: "buy-users"}) : intl.formatMessage({id: "invite_user"})}</b>
                  </h3>
                  <h5>{ !isEnterpriseUser(client) ? intl.formatMessage({ id: "create_user_here" }) : ""}</h5>
                  <input
                    className="form-control"
                    disabled={disableCreateUser}
                    name="email"
                    type="text"
                    value={email}
                    placeholder={intl.formatMessage({ id: "email" })}
                    onBlur={this.handleEmailExists}
                    onChange={this.handleInputOnChange}
                  />
                  <h5 style={{ padding: "5px 0" }}>
                    {intl.formatMessage({ id: "user_email_invitation" })}
                  </h5>
                  <h5>{intl.formatMessage({ id: "groups" })}</h5>
                  <Tooltip
                    title={
                      hireds
                        ? intl.formatMessage({ id: "disabled_input_group" })
                        : ""
                    }
                    placement="right"
                  >
                    {role === "operator" && (
                      <Form.Item>
                        <Select
                          defaultActiveFirstOption
                          disabled={hireds}
                          {...selected}
                          mode="multiple"
                          placeholder={intl.formatMessage({ id: "select" })}
                          onChange={this.handleOnChangeGroup}
                          style={{ width: "100%" }}
                        >
                          {options}
                        </Select>
                      </Form.Item>
                    )}
                  </Tooltip>
                  <div style={{ display: "flex", marginTop: "30px" }}>
                    {!isEnterpriseUser(client) && (
                      <span>
                        <input
                          style={{
                            cursor: "pointer",
                            marginRight: 5,
                            marginTop: 3
                          }}
                          type="checkbox"
                          id="terms"
                          name="terms"
                          checked={terms}
                          onChange={this.handleCheckboxOnChange}
                          disabled={disableCreateUser}
                        />
                        <label style={{ cursor: "pointer" }}>
                          {intl.formatMessage({
                            id: "accept_terms_of_service_p1"
                          })}
                          <a
                            href={USAGE_TERMS_LINK_FROM_HOME}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {intl.formatMessage({
                              id: "accept_terms_of_service_p2"
                            })}
                          </a>
                        </label>
                      </span>
                    )}
                    <Button
                      style={{ marginLeft: "auto", padding: "0 30px" }}
                      disabled={disableCreateUser}
                      type={"primary"}
                      onClick={() => this.sendInvitation()}
                    >
                      { !isEnterpriseUser(client) ? intl.formatMessage({id: "create"}) : intl.formatMessage({id: "invite_user"})}
                    </Button>
                  </div>
                </Col>
              </Row>
              {!isEnterpriseUser(client) && (
                <h3
                  style={{
                    color: "var(--primary-color)",
                    paddingBottom: "5px",
                    paddingTop: "10px"
                  }}
                >
                  <b>{intl.formatMessage({ id: "buy_bunkey" })}</b>
                </h3>
              )}
              {!isEnterpriseUser(client) && (
                <Row
                  style={{ paddingTop: "10px" }}
                  gutter={25}
                  type="flex"
                  justify="space-between"
                  align="bottom"
                >
                  {this.userServices().map(item => {
                    const result =
                      this.state.userPacks.find(
                        ({ _id }) => _id === item.idService
                      ) || item;
                    return (
                      <Col
                        lg={8}
                        md={24}
                        xs={24}
                        span={8}
                        style={{ padding: "20px" }}
                        key={item.idService}
                      >
                        <div className="container">
                          <Card
                            className="text-center"
                            id={item.idService}
                            style={{
                              background: "#EFF9FF",
                              borderRadius: 10,
                              border: "none"
                            }}
                            hoverable
                          >
                            <div
                              style={{
                                marginBottom: 18,
                                fontSize: 18,
                                fontWeight: 700
                              }}
                            >
                              <b>{item.product}</b>
                            </div>
                            <div
                              style={{
                                color: "var(--primary-color)",
                                fontSize: 16,
                                fontWeight: 700,
                                marginBottom: 25
                              }}
                            >
                              <b>{`Por solo ${item.price} USD`}</b>
                            </div>
                            <p style={{ marginBottom: 30 }}>
                              {item.description}
                            </p>
                            <Button
                              onClick={() =>
                                this.addUserPackQty(item.idService, -1)
                              }
                              style={{
                                backgroundColor: newColor,
                                borderColor: newColor,
                                color: "white",
                                borderRadius: 5,
                                padding: "0 5px"
                              }}
                              size={"small"}
                            >
                              <span>
                                <img
                                  src="/images/img_v2/icon-btn-minus.svg"
                                  alt="filtro"
                                />
                              </span>
                            </Button>
                            &nbsp;
                            <Button
                              type={"primary"}
                              ghost
                              style={{ color: newColor, borderRadius: 5 }}
                              size={"small"}
                            >
                              {result.quantity || 0}
                            </Button>
                            &nbsp;
                            <Button
                              onClick={() =>
                                this.addUserPackQty(item.idService, 1)
                              }
                              style={{
                                backgroundColor: newColor,
                                borderColor: newColor,
                                color: "white",
                                borderRadius: 5,
                                padding: "0 3px"
                              }}
                              size={"small"}
                            >
                              <span>
                                <img
                                  src="/images/img_v2/icon-btn-add.png"
                                  alt="filtro"
                                />
                              </span>
                            </Button>
                          </Card>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              )}
              {!isEnterpriseUser(client) && (
                <h3
                  style={{
                    color: "var(--primary-color)",
                    paddingBottom: "5px"
                  }}
                >
                  <b>{intl.formatMessage({ id: "buy_storage_space" })}</b>
                </h3>
              )}
              {!isEnterpriseUser(client) && (
                <Row gutter={25}>
                  {this.storageServices().map(item => {
                    const result =
                      this.state.userPacks.find(
                        ({ _id }) => _id === item.idService
                      ) || item;
                    return (
                      <Col
                        lg={8}
                        md={24}
                        xs={24}
                        span={8}
                        style={{ padding: "20px" }}
                        key={item.idService}
                      >
                        <div className="container">
                          <Card
                            className="text-center"
                            id={item.idService}
                            hoverable
                            style={{
                              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                              borderRadius: 10,
                              border: "none"
                            }}
                          >
                            <div
                              style={{
                                fontSize: 18,
                                fontWeight: 700,
                                marginBottom: 5,
                                color: "#6f6f6f"
                              }}
                            >
                              {item.product}
                            </div>
                            <div
                              style={{
                                color: "var(--primary-color)",
                                fontSize: 16,
                                fontWeight: 700,
                                marginBottom: 30
                              }}
                            >
                              <b>{`Por solo ${item.price} USD`}</b>
                            </div>
                            <p>{item.product}</p>
                            <div style={{ paddingTop: "20px" }}>
                              <Button
                                onClick={() =>
                                  this.addUserPackQty(item.idService, -1)
                                }
                                style={{
                                  backgroundColor: newColor,
                                  borderColor: newColor,
                                  color: "white",
                                  borderRadius: 5,
                                  padding: "0 5px"
                                }}
                                size={"small"}
                              >
                                <span>
                                  <img
                                    src="/images/img_v2/icon-btn-minus.svg"
                                    alt="filtro"
                                  />
                                </span>
                              </Button>
                              &nbsp;
                              <Button
                                type={"primary"}
                                ghost
                                style={{ color: newColor, borderRadius: 5 }}
                                size={"small"}
                              >
                                {result.quantity || 0}
                              </Button>
                              &nbsp;
                              <Button
                                onClick={() =>
                                  this.addUserPackQty(item.idService, 1)
                                }
                                style={{
                                  backgroundColor: newColor,
                                  borderColor: newColor,
                                  color: "white",
                                  borderRadius: 5,
                                  padding: "0 3px"
                                }}
                                size={"small"}
                              >
                                <span>
                                  <img
                                    src="/images/img_v2/icon-btn-add.png"
                                    alt="filtro"
                                  />
                                </span>
                              </Button>
                            </div>
                            {item.idService === "6424ad7089441071d65b7b23" && (
                              <div>
                                <p style={{ paddingTop: "20px" }}>
                                  <b>Gigabytes</b>
                                </p>
                                <Slider
                                  value={result.quantity || 0}
                                  min={0}
                                  max={1000}
                                  step={10}
                                  onChange={value =>
                                    this.updateUserPackQty(
                                      item.idService,
                                      value
                                    )
                                  }
                                  tooltip={{ open: true }}
                                ></Slider>
                                <div>
                                  <span style={{ float: "left" }}>0</span>
                                  <span style={{ float: "right" }}>1000</span>
                                  <span style={{ clear: "both" }}></span>
                                </div>
                              </div>
                            )}
                          </Card>
                        </div>
                      </Col>
                    );
                  })}
                  <Col
                    lg={8}
                    md={24}
                    xs={24}
                    span={8}
                    style={{ padding: "20px" }}
                  >
                    <div className="container"></div>
                  </Col>
                </Row>
              )}
            </div>
            {!isEnterpriseUser(client) && (
              <Row
                gutter={25}
                type="flex"
                justify="space-around"
                align="middle"
                style={{
                  paddingTop: "20px",
                  boxShadow: "rgb(0 0 0 / 50%) 0px -6px 6px -6px"
                }}
              >
                <Col md={9} xs={18} span={15}>
                  <div className="container">
                    <h4>
                      <b>
                        {intl.formatMessage({ id: "you_will_pay_monthly" })}
                      </b>
                    </h4>
                    <p>{intl.formatMessage({ id: "next_invoice_send" })}</p>
                  </div>
                </Col>
                <Col md={6} xs={6} span={15}>
                  <b style={{ color: newColor, fontSize: "24px" }}>
                    <span>$ {this.calculateTotal().toFixed(2)} USD</span>
                  </b>
                </Col>
                <Col md={9} xs={24} span={9}>
                  <div
                    style={{
                      textAlign: "right",
                      paddingRight: "20px"
                    }}
                  >
                    <Button
                      onClick={this.handleCancel}
                      type="default"
                      style={{ marginRight: "10px" }}
                    >
                      {intl.formatMessage({ id: "cancel_button" })}
                    </Button>
                    <Button type="primary" onClick={() => this.nextStep()}>
                      {intl.formatMessage({ id: "checkout" })}
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
          </div>
          {/*End step 1*/}

          <div hidden={step !== 2} id="step2" className="step">
            <Row gutter={25}>
              <Col md={14} xs={24} span={24}>
                <h4 className="title-dashboard">
                  <b className="color-title-dashboard">
                    {intl.formatMessage({ id: "payment_detail" })}
                  </b>
                </h4>
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead style={{ backgroundColor: newColor, color: "white" }}>
                  <tr>
                    <th>{intl.formatMessage({ id: "item" })}</th>
                    <th>{intl.formatMessage({ id: "product" })}</th>
                    <th>{intl.formatMessage({ id: "quantity" })}</th>
                    <th>{intl.formatMessage({ id: "price" })}</th>
                  </tr>
                </thead>
                <tbody>
                  {dataDiff.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item.item}</td>
                        <td>
                          {item.category === "features"
                            ? item.title
                            : item.product}
                        </td>
                        <td>
                          {item.type !== "3" && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: 100,
                                margin: "0 auto"
                              }}
                            >
                              {item.is_free !== "true" && (
                                <Button
                                  type={"primary"}
                                  style={{
                                    margin: "0 auto",
                                    display: "block",
                                    width: 27
                                  }}
                                  size={"small"}
                                  onClick={() =>
                                    this.addUserPackQty(item.idService, -1)
                                  }
                                >
                                  <span>
                                    <img
                                      src="/images/img_v2/icon-btn-minus.svg"
                                      alt="filtro"
                                    />
                                  </span>
                                </Button>
                              )}
                              <Button
                                style={{ margin: "0 auto", display: "block" }}
                                size={"small"}
                              >
                                {item.quantity}
                              </Button>
                              {item.category !== "features" &&
                                item.is_free !== "true" && (
                                  <Button
                                    type={"primary"}
                                    style={{
                                      margin: "0 auto",
                                      display: "block",
                                      width: 27,
                                      padding: "0 4px"
                                    }}
                                    size={"small"}
                                    onClick={() =>
                                      this.addUserPackQty(item.idService, 1)
                                    }
                                  >
                                    <span>
                                      <img
                                        src="/images/img_v2/icon-btn-add.png"
                                        alt="filtro"
                                      />
                                    </span>
                                  </Button>
                                )}
                            </div>
                          )}
                        </td>
                        <td>{item.quantity * item.price} USD</td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td colSpan={2} className="text-right"></td>
                    <td colSpan={1} className="left">
                      <b>TOTAL</b>
                    </td>
                    <td colSpan={1} className="left">
                      <b>{this.calculateTotal()} USD</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-right">
              <Button
                type="default"
                onClick={this.handleCancel}
                disabled={false}
                style={{ marginRight: "10px", fontWeight: "700" }}
              >
                {intl.formatMessage({ id: "cancel_button" })}
              </Button>
              <Button
                type="primary"
                disabled={false}
                onClick={this.updateClient}
                style={{ fontWeight: "700" }}
                loading={reducePlanLoading || linkGenerateLoading}
              >
                {intl.formatMessage({ id: "go_pay" })}
              </Button>
            </div>
          </div>
          {/*End step 2*/}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    contractedUsers:
      state.client && state.client.data
        ? state.client.data.contractedUsers
        : null,
    data: state.users.data,
    workclient: state.client.workclient,
    userExists: state.users.userExists,
    invitationSent: state.users.invitationSent,
    client: state.client.data,
    clientUpdate: state.client.clientUpdate,
    group: state.group.byClientData,
    planServices: state.planServices.data,
    userServices: state.planServices.userServices,
    usersData: state.users.data,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    reducePlanLoading: state.planServices.reducePlanLoading,
    reducePlanError: state.planServices.reducePlanError,
    linkGenerateLoading: state.planServices.linkGenerateLoading,
    linkGenerateError: state.planServices.linkGenerateError,
    linkGenerate: state.planServices.linkGenerate
  };
};

const mapDispatchToProps = {
  userExistsByEmail,
  userExistsReset,
  newInvitation,
  updateClientes,
  updatePlanServicesByUser,
  reducePlan,
  updatePlanLinkGenerate,
  getClientDataById
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AddModalUser))
);
